import React, { useContext } from 'react'
import { CustomAnchor, NoDataView } from '../../components'
import AuthContext from '../../common/contexts/auth'
import BaseLayout from '../../common/layout/BaseLayout';
import AuthLayout from '../../common/layout/AuthLayout';

const NotFound = () => {
    const { isAuthenticated } = useContext(AuthContext);
    return (
        <Wrapper isAuthenticated={isAuthenticated}>
            <div className='not-found-container'>
                <NoDataView size='large' noDataText=" ">
                    <p className='title'>Oops, nothing here</p>
                    <p className='subtitle'>404 - Page not found</p>
                    <CustomAnchor href={isAuthenticated ? "/products" : "/signin"}>{isAuthenticated ? "Go to homepage" : "Sign in"}</CustomAnchor>
                </NoDataView>
            </div>
        </Wrapper>
    )
}

const Wrapper = ({ children, isAuthenticated }) => {
    return isAuthenticated ? (
        <BaseLayout>{children}</BaseLayout>
    ) : (
        <AuthLayout>{children}</AuthLayout>
    )
}

export default NotFound